import moment from "moment";
import { BaseEntity, getCachedPlanetEntity, getCachedSolarSystemEntity } from ".";
import { IGet_characters_character_id_planets_200_ok } from "../service/esiclient";
import { getCachedCharacterEntity } from "./CharacterEntityCache";
export class CharacterPlanetEntity extends BaseEntity {
  constructor(id: number, props: any, character_id: any) {
    super(id, props);
    this._dataTypeName = "Character Planet";
    this._character_id = character_id;
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_characters_character_id_planets_200_ok> = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      //delete entity.properties["id"];
      const characterEntity = await getCachedCharacterEntity(this._character_id);
      if (characterEntity !== null) {
        entity.properties["owner"] = await characterEntity.toJson();
      }
      if (props.last_update) {
        const date = moment(props.last_update);
        entity.properties["last_updated"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: date.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      let planetName = props.planet_id ? props.planet_id : "Unknown Planet";
      if (props.planet_id) {
        const planetEntity = await getCachedPlanetEntity(props.planet_id);
        if (planetEntity !== null) {
          entity.properties["planet"] = await planetEntity.toJson();
          planetName = planetEntity.props.name ?? props.planet_id;
        }
      }
      if (props.solar_system_id) {
        let systemEntity = await getCachedSolarSystemEntity(props.solar_system_id);
        if (systemEntity !== null) {
          entity.properties["solar_system"] = await systemEntity.toJson();
        }
      }
      let planetType = " (Type) - ";
      if (props.planet_type) {
        planetType = " (" + props.planet_type.charAt(0).toUpperCase() + props.planet_type.slice(1) + ")";
      }
      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: planetName + planetType,
      };
      entity.text = planetName + planetType;
    }
    // Layouts
    entity.layouts = {
      card: {
        //title: { property: "name" },
      },
    };

    return entity;
  }
}
